import FrontApp from './components/Front'

// Sync route definition
export default {
  path: '/front',
  component : FrontApp
}
